// ⚠️ 此文件由 api:gen 自动生成，请勿手动修改
// 源: capabilities/article.yaml
// 生成时间: 2026-09-09T10:41:27.309Z
import http from '../http';

export default {
  // 列表 article.list
  list: (data) => http.get('content-service/cnt_article/page_org', data),

  // 详情 article.get
  get: (id) => http.get('content-service/cnt_article/' + id),

  // 创建文章。关联数据请先按需调用 MCP 工具：article_type_tree（分类）、basic_fieldList（领域）、basic_industryList（行业）、basic_productList（产品）、basic_tagList（标签），再按各字段 desc 构造请求体。 article.create
  create: (data) => http.post('content-service/cnt_article', data),

  // 更新文章（实体全量回传模式）。必须先调 article_get 获取完整详情对象，在其基础上仅修改目标字段，其余字段（含 IR 未枚举的系统字段，如 page_headline、gmtCreate、dr 等）原样回传后整体 PUT；缺失字段会被后端覆盖/清空，勿自行裁剪对象。categoriesObj/fieldsObj/industriesObj 等对象字段随详情原样带回，不要重新构造。 article.update
  update: (data) => http.put('content-service/cnt_article', data),

  // 删除 article.delete
  delete: (id) => http.delete('content-service/cnt_article/' + id, {}),

  type: {
    // 文章分类树 article.type.tree
    tree: (data) => http.get('content-service/cnt_category/tree', data),

    // 新增文章分类 article.type.add
    add: (data) => http.post('content-service/cnt_category', data),

    // 更新文章分类 article.type.update
    update: (data) => http.put('content-service/cnt_category', data),

    // 删除文章分类 article.type.delete
    delete: (id) => http.delete('content-service/cnt_category/' + id, {}),
  },

  // 文章列表（开放租户） article.list_all
  list_all: (data) => http.get('content-service/cnt_article/page_opentenant', data),

  // 从微信链接提取文章素材 article.import_url
  import_url: (data) => http.post('content-service/cnt_article/reptile', data),

  template: {
    // 模板列表（全部组织） article.template.list_org
    list_org: (data) => http.post('content-service/prompt/template/page/orgs/all', data),

    // 模板列表（全部租户） article.template.tenant_all
    tenant_all: (data) => http.post('content-service/prompt/template/list/tenant/all', data),

    // 模板详情 article.template.info
    info: (id) => http.get('content-service/prompt/template/' + id),

    // 新增模板 article.template.add
    add: (data) => http.post('content-service/prompt/template', data),

    // 更新模板 article.template.update
    update: (data) => http.put('content-service/prompt/template', data),

    // 删除模板 article.template.del
    del: (id) => http.delete('content-service/prompt/template/' + id, {}),
  },

  bigName: {
    // 大V列表 article.bigName.page
    page: (data) => http.post('friendservice/bigName/page', data),

    // 保存大V博客 article.bigName.save
    save: (data) => http.post('friendservice/bigNameBlog/save', data),
  },

  // 文章专题 article.topic
  topic: (data) => http.get('content-service/cnt_article/page/for/topic', data),
};
